<template>
  <mpx-input-group
    v-bind="$attrs"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    @reset-input="$emit('reset-input')"
    @icon-append-click="$emit('icon-append-click')"
    @icon-prepend-click="$emit('icon-prepend-click')"
  >
    <template #default="{setLocalValue, setOnHover, emitOnBlur, emitOnFocus}">
      <input
        ref="inputText"
        v-bind="$attrs"
        :id="$attrs.id ? `input-${$attrs.id}` : null"
        :class="[
          `${prefix}input`,
          { ...getInputClasses }
        ]"
        :value="value"
        @blur="(e) => {
          $emit('blur', e);
          emitOnBlur(e);
        }"
        @focus="(e) => {
          $emit('focus', e);
          emitOnFocus(e);
        }"
        @click="$emit('click', $event);"
        @mouseenter="setOnHover(true)"
        @mouseleave="setOnHover(false)"
        @input="(e) => {
          setLocalValue(e.target.value);
        }"
      />
    </template>
  </mpx-input-group>
</template>

<script>
import MpxInputGroup from '../InputGroup';

export default {
  name: 'MpxTextField',
  components: {
    MpxInputGroup,
  },
  props: {
    prefix: {
      type: String,
      default: 'mpx-',
    },
    size: {
      type: String,
      default: null,
    },
    error: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number, Date],
      default: null,
    },
  },
  watch: {
    value(newValue) {
      this.updateInputGroupValue(newValue);
    },
  },
  computed: {
    getInputClasses() {
      const classes = {};
      classes[`${this.prefix}input--small`] = this.size === 'small';
      classes[`${this.prefix}error`] = this.error;
      return classes;
    },
  },
  mounted() {
    this.updateInputGroupValue();
  },
  methods: {
    updateInputGroupValue() {
      if (this.value) {
        const event = new Event('input', {
          bubbles: true,
          cancelable: true,
        });
        this.$nextTick(() => {
          this.$refs.inputText.dispatchEvent(event);
        });
      }
    },
  },
};
</script>
